import React from 'react';
import moment from 'moment';
import { Button } from 'antd';

const Columns = (disableSubmit, processing, updating, deleting, handleUpdate, handleDelete) => {
  return [
    {
      title: 'Brand',
      dataIndex: 'brand',
      width: '20%',
      align: 'left',
      render: (text, record) => {
        return (
          <div>
            <div>{text}</div>
            {record.isNotExact && <div className='gx-text-danger'>(Insert manually)</div>}
          </div>
        )
      },
    },
    {
      title: 'Industry',
      dataIndex: 'industry',
      width: '20%',
      align: 'center',
    },
    {
      title: 'Category',
      dataIndex: 'category',
      width: '20%',
      align: 'center',
    },
    {
      title: 'Month Buzz Volume',
      dataIndex: 'value',
      width: '10%',
      editable: true,
      align: 'center',
    },
    {
      title: 'Updated at',
      dataIndex: 'updated_at',
      align: 'left',
      width: '10%',
      render: (text) => moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      title: 'Tùy chỉnh',
      align: 'center',
      render: (_, record) => {
        return (
          <div style={{ marginTop: 16 }}>
            <Button loading={processing === record.id && updating} disabled={disableSubmit === record.id || (processing === record.id && deleting)} onClick={() => handleUpdate(record.id)} icon='check' type='primary'>Save</Button>
            <Button loading={processing === record.id && deleting} disabled={processing === record.id && updating} onClick={() => handleDelete(record.id)} icon='delete' type='danger'>Delete</Button>
          </div>
        )
      },
    },
  ];
};

export default Columns;
